const dev = {
  API_ENDPOINT_URL: 'http://localhost:8080',
  RECAPTCHA_SITE_KEY: '6LfbgoksAAAAALMeKppaAU_ySw0wEcKBES9ipZHh'
};

const prod = {
  API_ENDPOINT_URL: '/api',
  RECAPTCHA_SITE_KEY: '6LfbgoksAAAAALMeKppaAU_ySw0wEcKBES9ipZHh'
};

const test = {
  API_ENDPOINT_URL: '/api',
  RECAPTCHA_SITE_KEY: '6LfbgoksAAAAALMeKppaAU_ySw0wEcKBES9ipZHh'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
